<template>
  <v-dialog
    v-model="opened"
    content-class="date-time-picker"
    max-width="350"
    persistent
  >
    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#eee"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-date-picker
          v-model="date"
          class="elevation-0"
          :locale="$i18n.locale"
          :max="new Date().toISOString().substr(0, 10)"
          full-width
        />
        <v-btn
          class="d-block ml-auto mr-3"
          color="warning"
          elevation="0"
          text
          :disabled="!date"
          @click="tab = 1"
        >
          {{ $t('common.button.next') }}
        </v-btn>
      </v-tab-item>

      <v-tab-item>
        <v-btn class="date-time-picker__back" icon @click="tab = 0">
          <v-icon size="27" color="#eee">mdi-arrow-left</v-icon>
        </v-btn>

        <v-time-picker
          v-model="time"
          format="24hr"
          class="elevation-0"
          full-width
        />

        <div class="date-time-picker__buttons">
          <v-btn
            class="d-block"
            color="warning"
            elevation="0"
            max-width="300px"
            block
            :disabled="!time"
            @click="onSave"
          >
            {{ $t('common.btns.save') }}
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'close',
  },
  props: {
    value: Boolean,
    dateTime: {
      type: String,
      default: '',
    },
  },
  watch: {
    opened(value) {
      if (!value) {
        this.date = '';
        this.time = '';
        this.tab = 0;
      } else {
        if (!this.dateTime) return;

        const [date, time] = this.dateTime.split(' ');
        this.date = date;
        this.time = time;
      }
    },
  },
  data: () => ({
    tab: 0,
    date: '',
    time: '',
  }),
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('close', val);
      },
    },
  },
  methods: {
    onSave() {
      const time = `${this.date} ${this.time}`;
      const withSeconds = time.length === 19;

      this.$emit('change', withSeconds ? time : `${time}:00`);
      this.opened = false;
    },
  },
};
</script>

<style lang="scss">
.date-time-picker {
  background-color: #fff;
  padding-bottom: 10px;

  &__back {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 10;
  }

  &__buttons {
    margin-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .v-time-picker-title {
    justify-content: center;
  }

  .v-btn--text {
    text-decoration: none !important;
  }
}
</style>
